// Autogenerated locales - do not modify
/* tslint:disable quotemark variable-name */
export const EMOJI_REACTION_ANGRY = "Hnev\u00e1 ma to";
export const EMOJI_REACTION_CARE = "Posielam podporu";
export const EMOJI_REACTION_HAHA = "Pobavilo";
export const EMOJI_REACTION_LIKE = "P\u00e1\u010di sa mi";
export const EMOJI_REACTION_LOVE = "Skvel\u00e9";
export const EMOJI_REACTION_SAD = "Mrz\u00ed ma to";
export const EMOJI_REACTION_WOW = "Prekvapilo";
